import { User } from '@adsk/alloy-provider';

export const sortUsersAlphabetically = (items: User[]) =>
  items.sort((a, b) => a.name.localeCompare(b.name));
